const styles = {
  container: {
    color: 'black',
    padding: '10px 20px',
  },
  madeBy: {
    margin: '0px',
    marginLeft: '20px',
    lineHeight: '1.3',
  },
  title: {
    color: '#ce1f2c',
    textAlign: 'center',
    fontSize: '20px',
    fontWeight: 'bold',
    lineHeight: '1.3',
    margin: '20px 0px',
  },
  whiteSpace: {
    marginBottom: '20px',
  },
  warning: {
    color: '#ce1f2c',
    fontWeight: 'bold',
  },
  gap: {
    marginLeft: '12px',
  },
  date: {
    textAlign: 'right',
  },
  imgWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  img: {
    maxWidth: '100%',
  },

  // header
  header: {
    backgroundColor: '#da291c',
    color: 'white',
    borderTopLeftRadius: '6px',
    borderTopRightRadius: '6px',
    padding: '26px',
    boxShadow: `rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
        rgba(0, 0, 0, 0.3) 0px 3px 7px -3px`,
  },

  titleHeaderWrapper: {
    margin: '0 auto',
  },
  titleHeader: {
    margin: '0px',
    textAlign: 'center',
    fontSize: '22px',
  },
  // list

  listWrapper: {
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    listStyleType: 'none',
    borderRadius: '6px',
    backgroundColor: '#f7f7f7',
    padding: '20px',
    boxShadow: ` rgba(50, 50, 93, 0.25) 0px 50px 100px -20px,
        rgba(0, 0, 0, 0.3) 0px 30px 60px -30px,
        rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset`,
  },

  icon: {
    fontSize: '22px',
    color: 'black',
  },
  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  label: {
    fontWeight: 'bold',
  },

  text: {
    lineHeight: '1.1',
    color: '#ce1f2c',
    cursor: 'pointer',
  },

  // instructions
  instructionsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    margin: '20px 12px',
    borderRadius: '6px',
    backgroundColor: ' #f7f7f7',
  },

  instructionTitle: {
    width: '100%',
    marginBottom: '30px',
    marginTop: '30px',
    textAlign: 'center',
  },
  name: {
    margin: 0,
    textAlign: 'center',
    color: '#ce1f2c',
    fontWeight: 'bold',
  },
  flex: {
    display: 'flex',
    flexDirection: 'column',
  },
};
export default styles;
